module.exports = __webpack_public_path__ + "static/media/icons-yc-qrcode.a9ec38a2.svg";